const ResetPasswordPage = () => {
    return ( <>Reset password</> );
}
 
export default ResetPasswordPage;